<layout-block-list-outlet [list]="layout?.layout"></layout-block-list-outlet>
